export const useInfinityScroll = (fetch: () => Promise<any>, initialPage: number = 0) => {
    const loadMoreElement = useTemplateRef<HTMLElement>('loadMoreElement')
    const isFetching = ref<boolean>(false)
    const firstFetch = ref<boolean>(true)
    const currentPage = ref<number>(initialPage)
    const lastPage = ref<number | undefined>()
    const canGoNextPage = computed<boolean>(() => {
        if (lastPage.value === undefined) {
            return true;
        }
        if (currentPage.value === undefined) {
            return lastPage.value !== 0 && lastPage.value !== 1
        }
        return currentPage.value < lastPage.value
    })

    async function nextPage() {
        if (!canGoNextPage) return;
        currentPage.value += 1
        await fetch()
    }

    async function fetchNextPage() {
        if (canGoNextPage.value && !isFetching.value) {
            try {
                isFetching.value = true
                await nextPage()
                isFetching.value = false
                firstFetch.value = false
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    onMounted(() => {
        if (loadMoreElement) {
            const elIsVisible = useElementVisibility(loadMoreElement, {
                threshold: 1
            })
            let int: number | undefined = undefined
            watch(elIsVisible, async (value) => {
                if (value) {
                    console.debug('Element visible. Start fetching.')
                    int = setInterval(async () => await fetchNextPage()) as unknown as number
                } else {
                    console.debug('Element is not visible. Stop fetching.')
                    clearInterval(int)
                    int = undefined
                }
            })
        }
    })

    return {
        loadMoreElement,
        currentPage,
        lastPage,
        canGoNextPage,
        fetchNextPage,
        firstFetch,
        isFetching
    }
}
